"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var InteractionSearchResultsTableRow_1 = require("./InteractionSearchResultsTableRow");
var CompareInteractionsModal_1 = require("../../CompareInteractionsModal");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../../Types");
var rxjs_1 = require("rxjs");
var InteractionSearchResultsTableWithComparison = /** @class */ (function (_super) {
    __extends(InteractionSearchResultsTableWithComparison, _super);
    function InteractionSearchResultsTableWithComparison(props) {
        var _this = _super.call(this, props) || this;
        _this.onInteractionSelection = function (interactionId) {
            _this.setState(function (prevState) {
                var alreadySelected = prevState.selectedInteractions.includes(interactionId);
                return {
                    selectedInteractions: alreadySelected
                        ? prevState.selectedInteractions.filter(function (x) { return x !== interactionId; })
                        : __spreadArray(__spreadArray([], prevState.selectedInteractions, true), [interactionId], false)
                };
            });
        };
        _this.toggleCompareInteractionsModal = function () {
            if (_this.getInteractionsKey() !== _this.state.previousInteractionsKey) {
                _this.loadInteractions();
            }
            _this.setState(function (prevState) { return ({
                showComparedInteractions: !prevState.showComparedInteractions
            }); });
        };
        _this.state = {
            selectedInteractions: [],
            interactionsLoaded: false,
            showComparedInteractions: false,
            previousInteractionsKey: ""
        };
        return _this;
    }
    InteractionSearchResultsTableWithComparison.prototype.componentDidUpdate = function () {
        if (this.props.resetCompareSelection) {
            this.resetCompareSelection();
            this.props.onResetCompareSelectionHandle();
        }
    };
    InteractionSearchResultsTableWithComparison.prototype.render = function () {
        var buttonDisabled = !this.isMaxSelectionReached;
        return this.props.interactions && this.props.interactions.length > 0 && ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", { className: "col-12 table-responsive", children: (0, jsx_runtime_1.jsxs)("table", { className: "table table-striped table-hover table-sm", children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("th", { scope: "col" }), (0, jsx_runtime_1.jsx)("th", { scope: "col", children: "Interaction ID" }), (0, jsx_runtime_1.jsx)("th", { scope: "col", children: "Modification date" }), (0, jsx_runtime_1.jsx)("th", { scope: "col", children: "Status" }), (0, jsx_runtime_1.jsx)("th", { scope: "col", children: "Process" }), (0, jsx_runtime_1.jsx)("th", { scope: "col", children: "Cover tier" }), (0, jsx_runtime_1.jsx)("th", { scope: "col", children: "Annual premium" }), (0, jsx_runtime_1.jsx)("th", { scope: "col", children: "Underwriting error" })] }) }), (0, jsx_runtime_1.jsx)("tbody", { children: this.renderSearchResultRows() })] }) }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(CompareInteractionsModal_1.default, { showComparedInteractions: this.state.showComparedInteractions, hideComparedInteractions: this.toggleCompareInteractionsModal, interactionsLoaded: this.state.interactionsLoaded, firstInteraction: this.state.firstInteraction, secondInteraction: this.state.secondInteraction, fallbackMessage: this.state.fallbackMessage }), (0, jsx_runtime_1.jsx)("button", { type: "button", disabled: buttonDisabled, className: "btn btn-primary mt-3", onClick: this.toggleCompareInteractionsModal, children: "Compare Interactions" })] })] }));
    };
    InteractionSearchResultsTableWithComparison.prototype.resetCompareSelection = function () {
        this.setState({
            selectedInteractions: [],
            interactionsLoaded: false,
            showComparedInteractions: false,
            previousInteractionsKey: ""
        });
    };
    Object.defineProperty(InteractionSearchResultsTableWithComparison.prototype, "isMaxSelectionReached", {
        get: function () {
            return this.state.selectedInteractions.length >= 2;
        },
        enumerable: false,
        configurable: true
    });
    InteractionSearchResultsTableWithComparison.prototype.renderSearchResultRows = function () {
        var _this = this;
        return this.props.interactions.map(function (interaction, index) {
            var checked = _this.state.selectedInteractions.includes(interaction._id);
            var boxDisabled = !checked && _this.isMaxSelectionReached;
            return ((0, jsx_runtime_1.jsx)(InteractionSearchResultsTableRow_1.InteractionSearchResultsTableRow, { interaction: interaction, checked: checked, boxDisabled: boxDisabled, onInteractionSearchClick: _this.props.onInteractionSearchClick, onInteractionSelection: _this.onInteractionSelection }, index));
        });
    };
    InteractionSearchResultsTableWithComparison.prototype.getInteractionsKey = function () {
        var _a = __spreadArray([], this.state.selectedInteractions, true).sort(function (x, y) { return x - y; }), firstInteraction = _a[0], secondInteraction = _a[1];
        return "".concat(firstInteraction, "|").concat(secondInteraction);
    };
    InteractionSearchResultsTableWithComparison.prototype.loadInteractions = function () {
        var _this = this;
        this.setState({
            interactionsLoaded: false,
            fallbackMessage: "Loading..."
        });
        var _a = this.state.selectedInteractions, firstInteractionId = _a[0], secondInteractionId = _a[1];
        var firstInteraction = this.supportPortalService.getInteraction(firstInteractionId.toString());
        var secondInteraction = this.supportPortalService.getInteraction(secondInteractionId.toString());
        (0, rxjs_1.forkJoin)([firstInteraction, secondInteraction])
            .pipe()
            .subscribe({
            next: function (_a) {
                var fi = _a[0], si = _a[1];
                _this.setState({
                    firstInteraction: fi,
                    secondInteraction: si,
                    previousInteractionsKey: _this.getInteractionsKey(),
                    interactionsLoaded: true
                });
            },
            error: function () {
                _this.setState({ fallbackMessage: "Error loading interactions data" });
            }
        });
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], InteractionSearchResultsTableWithComparison.prototype, "supportPortalService", void 0);
    InteractionSearchResultsTableWithComparison = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], InteractionSearchResultsTableWithComparison);
    return InteractionSearchResultsTableWithComparison;
}(React.Component));
exports.default = InteractionSearchResultsTableWithComparison;
//# sourceMappingURL=InteractionSearchResultsTableWithComparison.js.map